import { TableColumnKey, TableRow } from "../types/Table";

type Props = {
  rows: TableRow[];
};

const useSorting = (props: Props) => {
  const { rows } = props;

  //1. Threshold Reached (red rows first)
  const getThresholdSorted = (item: TableRow) => {
    if (
      item.isAmountLargerThanThreshold &&
      item.isWalletCountLargerThanThreshold
    )
      return 2;
    if (
      item.isAmountLargerThanThreshold ||
      item.isWalletCountLargerThanThreshold
    )
      return 1;
    return 0;
  };

  const sortedRows = rows
    //5. Smart Account Type (Yes before No)
    .sort(
      (itemA, itemB) =>
        Number(itemB?.isSmartAccount) - Number(itemA?.isSmartAccount),
    )
    //4. Currency (alphabetical)
    .sort((itemA, itemB) =>
      (itemA?.currency ?? "").localeCompare(itemB?.currency ?? ""),
    )
    //3. Wallet Major Version (descending — 1 before 0, newest version first)
    .sort(
      (itemA, itemB) =>
        Number(itemB?.walletMajorVersion ?? 0) -
        Number(itemA?.walletMajorVersion ?? 0),
    )
    //2. Chain (alphabetical)
    .sort((itemA, itemB) =>
      (itemA?.chainName ?? "").localeCompare(itemB?.chainName ?? ""),
    )
    //1. Threshold Reached (red rows first)
    .sort(
      (itemA, itemB) => getThresholdSorted(itemB) - getThresholdSorted(itemA),
    );

  return { sortedRows };
};
export default useSorting;
